export const SET_SIGN_UP_ACCOUNT_TYPE = 'SET_SIGN_UP_ACCOUNT_TYPE';
export const setSignUpAccountType = (data) => ({
	type: SET_SIGN_UP_ACCOUNT_TYPE,
	data,
});

/*
 * SIGN UP ACTION FACTORY
 */
export const signUpAction = (actionType, name) => (value) => {
	return {
		type: actionType,
		name,
		value,
	};
};

export const SET_PROGRESS_STEP = 'SET_PROGRESS_STEP';
export const setProgressStep = (stepCompletedIndex) => {
	return signUpAction(SET_PROGRESS_STEP, `progress-step-${stepCompletedIndex}`)(true);
};

export const SET_SKIP_BANK_LINK = 'SET_SKIP_BANK_LINK';
export const setSkipBankLink = signUpAction(SET_SKIP_BANK_LINK, 'skip-bank-link');

export const SET_COMPLETED_REFERRAL = 'SET_COMPLETED_REFERRAL';
export const setCompletedReferral = signUpAction(SET_COMPLETED_REFERRAL, 'referral');

export const SET_PORTFOLIO_BUILDER_HANDOFF_COMPLETE = 'SET_PORTFOLIO_BUILDER_HANDOFF_COMPLETE';
export const setPortfolioBuilderHandoffComplete = signUpAction(
	SET_PORTFOLIO_BUILDER_HANDOFF_COMPLETE,
	'portfolio-builder-handoff-complete'
);

// TODO: Remove this once billing frequency is tested.
export const SET_BILLING_PERIOD = 'SET_BILLING_PERIOD';
export const setBillingPeriod = (billingPeriod) => ({
	type: SET_BILLING_PERIOD,
	billing_period: billingPeriod,
});

export const SET_BILLING_FREQUENCY = 'SET_BILLING_FREQUENCY';
export const setBillingFrequency = (billing_frequency_id) => ({
	type: SET_BILLING_FREQUENCY,
	billing_frequency_id,
});

export const SET_BILLING_FREQUENCIES = 'SET_BILLING_FREQUENCIES';
export const setBillingFrequencies = (billingFrequencies) => ({
	type: SET_BILLING_FREQUENCIES,
	billingFrequencies,
});

export const SET_BILLING_SUMMARY = 'SET_BILLING_SUMMARY';
export const setBillingSummary = signUpAction(SET_BILLING_SUMMARY, 'billing-summary');

export const SET_EMPLOYED = 'SET_EMPLOYED';
export const setEmployed = signUpAction(SET_EMPLOYED, 'employed');

export const SET_ADD_TRUSTED_CONTACT = 'SET_ADD_TRUSTED_CONTACT';
export const setAddTrustedContact = signUpAction(SET_ADD_TRUSTED_CONTACT, 'add-trusted-contact');

export const SET_WELCOME_TO_STASH_COMPLETE = 'SET_WELCOME_TO_STASH_COMPLETE';
export const setWelcomeToStash = signUpAction(
	SET_WELCOME_TO_STASH_COMPLETE,
	'set-welcome-to-stash-complete'
);

export const SET_SCHEDULE_COMPLETE = 'SET_SCHEDULE_COMPLETE';
export const setScheduleComplete = signUpAction(SET_SCHEDULE_COMPLETE, 'set-schedule-complete');

export const SET_FIRST_DEPOSIT_COMPLETE = 'SET_FIRST_DEPOSIT_COMPLETE';
export const setFirstDepositComplete = signUpAction(
	SET_FIRST_DEPOSIT_COMPLETE,
	'first-deposit-complete'
);

export const SET_SMART_SUCCESS_COMPLETE = 'SET_SMART_SUCCESS_COMPLETE';
export const setSmartSuccessComplete = signUpAction(
	SET_SMART_SUCCESS_COMPLETE,
	'set-smart-success-complete'
);

export const SET_ONBOARDING_COMPLETE = 'SET_ONBOARDING_COMPLETE';
export const setOnboardingComplete = signUpAction(
	SET_ONBOARDING_COMPLETE,
	'set-onboarding-complete'
);

export const SET_AUTO_INVEST_MIX = 'SET_AUTO_INVEST_MIX';
export const setAutoInvestMix = signUpAction(SET_AUTO_INVEST_MIX, 'set-auto-invest-mix');

export const SET_BANK_LINK_OAUTH = 'SET_BANK_LINK_OAUTH';
export const setBankLinkOAuth = signUpAction(SET_BANK_LINK_OAUTH, 'bank-link-oauth');

export const SET_ADD_CASH = 'SET_ADD_CASH';
export const setAddCash = signUpAction(SET_ADD_CASH, 'set-add-cash');

export const SET_ADD_CASH_AMOUNT_COMPLETE = 'SET_ADD_CASH_AMOUNT_COMPLETE';
export const setAddCashAmountComplete = signUpAction(
	SET_ADD_CASH_AMOUNT_COMPLETE,
	'set-add-cash-amount-complete'
);

export const SET_AUTO_INVEST_ADD_CASH_SUMMARY_COMPLETE =
	'SET_AUTO_INVEST_ADD_CASH_SUMMARY_COMPLETE';
export const setAutoInvestAddCashSummaryComplete = signUpAction(
	SET_AUTO_INVEST_ADD_CASH_SUMMARY_COMPLETE,
	'set-add-cash-summary-complete'
);

export const SET_ADD_CASH_SUCCESS_COMPLETE = 'SET_ADD_CASH_SUCCESS_COMPLETE';
export const setAddCashSuccessComplete = signUpAction(
	SET_ADD_CASH_SUCCESS_COMPLETE,
	'set-add-cash-success-complete'
);

export const SET_SMART_PORTFOLIO_ALLOCATION_COMPLETE = 'SET_SMART_PORTFOLIO_ALLOCATION_COMPLETE';
export const setSmartPortfolioAllocationComplete = signUpAction(
	SET_SMART_PORTFOLIO_ALLOCATION_COMPLETE,
	'smart-portfolio-allocation-complete'
);

export const SET_SMART_PORTFOLIO_TRANSITION_COMPLETE = 'SET_SMART_PORTFOLIO_TRANSITION_COMPLETE';
export const setSmartPortfolioTransitionComplete = signUpAction(
	SET_SMART_PORTFOLIO_TRANSITION_COMPLETE,
	'smart-portfolio-transition-complete'
);

export const SET_SMART_PORTFOLIO_V2_TRANSITION_COMPLETE =
	'SET_SMART_PORTFOLIO_V2_TRANSITION_COMPLETE';
export const setSmartPortfolioV2TransitionComplete = signUpAction(
	SET_SMART_PORTFOLIO_V2_TRANSITION_COMPLETE,
	'smart-portfolio-v2-transition-complete'
);

export const SET_INVESTMENT_SELECTION_COMPLETE = 'SET_INVESTMENT_SELECTION_COMPLETE';
export const setInvestmentSelectionComplete = signUpAction(
	SET_INVESTMENT_SELECTION_COMPLETE,
	'set-investment-selection-complete'
);

export const SET_INVESTMENT_DETAIL_COMPLETE = 'SET_INVESTMENT_DETAIL_COMPLETE';
export const setInvestmentDetailComplete = signUpAction(
	SET_INVESTMENT_DETAIL_COMPLETE,
	'set-investment-detail-complete'
);

export const SKIP_TO_LINK_BANK_PRIMER = 'SKIP_TO_LINK_BANK_PRIMER';
export const skipToLinkBankPrimer = signUpAction(
	SKIP_TO_LINK_BANK_PRIMER,
	'skip-to-link-bank-primer'
);

export const SET_LINK_BANK_PRIMER_COMPLETE = 'SET_LINK_BANK_PRIMER_COMPLETE';
export const setLinkBankPrimerComplete = signUpAction(
	SET_LINK_BANK_PRIMER_COMPLETE,
	'set-link-bank-primer-complete'
);

export const SET_LINK_BANK_LATER = 'SET_LINK_BANK_LATER';
export const setLinkBankLater = signUpAction(SET_LINK_BANK_LATER, 'set-link-bank-later');

export const SET_DUPLICATE_SSN_BLOCK_SCREEN = 'SET_DUPLICATE_SSN_BLOCK_SCREEN';
export const setDuplicateSSNBlockScreen = signUpAction(
	SET_DUPLICATE_SSN_BLOCK_SCREEN,
	'set-duplicate-ssn-block-screen'
);

export const SET_VALID_SSN_COMPLETE = 'SET_VALID_SSN_COMPLETE';
export const setValidSSNComplete = signUpAction(SET_VALID_SSN_COMPLETE, 'valid-ssn-complete');

export const SET_STATE_ZERO_HOME_COMPLETE = 'SET_STATE_ZERO_HOME_COMPLETE';
export const setStateZeroHomeComplete = signUpAction(
	SET_STATE_ZERO_HOME_COMPLETE,
	'set-state-zero-home-complete'
);

export const SET_STATE_ZERO_HOME_V2_COMPLETE = 'SET_STATE_ZERO_HOME_V2_COMPLETE';
export const setStateZeroHomeV2Complete = signUpAction(
	SET_STATE_ZERO_HOME_COMPLETE,
	'set-state-zero-home-v2-complete'
);

export const SET_RETIRE_STATE_ZERO_COMPLETE = 'SET_RETIRE_STATE_ZERO_COMPLETE';
export const setRetireStateZeroComplete = signUpAction(
	SET_RETIRE_STATE_ZERO_COMPLETE,
	'set-retire-state-zero-complete'
);

export const SET_RETIRE_QUESTIONS_PRIMER_COMPLETE = 'SET_RETIRE_QUESTIONS_PRIMER_COMPLETE';
export const setRetireQuestionsPrimerComplete = signUpAction(
	SET_RETIRE_QUESTIONS_PRIMER_COMPLETE,
	'retire-questions-primer-complete'
);

export const SET_RETIRE_MARITAL_STATUS_COMPLETE = 'SET_RETIRE_MARITAL_STATUS_COMPLETE';
export const setRetireMaritalStatusComplete = signUpAction(
	SET_RETIRE_MARITAL_STATUS_COMPLETE,
	'retire-marital-status-complete'
);

export const SET_RETIRE_TAX_FILING_STATUS_COMPLETE = 'SET_RETIRE_TAX_FILING_STATUS_COMPLETE';
export const setRetireTaxFilingStatusComplete = signUpAction(
	SET_RETIRE_TAX_FILING_STATUS_COMPLETE,
	'retire-tax-filing-status-complete'
);

export const SET_RETIRE_COMBINED_ANNUAL_INCOME_COMPLETE =
	'SET_RETIRE_COMBINED_ANNUAL_INCOME_COMPLETE';
export const setRetireCombinedAnnualIncomeComplete = signUpAction(
	SET_RETIRE_COMBINED_ANNUAL_INCOME_COMPLETE,
	'retire-combined-annual-income-complete'
);

export const SET_RETIRE_ANNUAL_INCOME_COMPLETE = 'SET_RETIRE_ANNUAL_INCOME_COMPLETE';
export const setRetireAnnualIncomeComplete = signUpAction(
	SET_RETIRE_ANNUAL_INCOME_COMPLETE,
	'retire-annual-income-complete'
);

export const SET_RETIRE_WORKPLACE_RETIREMENT_PLAN_COMPLETE =
	'SET_RETIRE_WORKPLACE_RETIREMENT_PLAN_COMPLETE';
export const setRetireWorkplaceRetirementPlanComplete = signUpAction(
	SET_RETIRE_WORKPLACE_RETIREMENT_PLAN_COMPLETE,
	'retire-workplace-retirement-plan-complete'
);

export const SET_RETIRE_RECOMMENDATION_TRANSITION_COMPLETE =
	'SET_RETIRE_RECOMMENDATION_TRANSITION_COMPLETE';
export const setRetireRecommendationTransitionComplete = signUpAction(
	SET_RETIRE_RECOMMENDATION_TRANSITION_COMPLETE,
	'retire-recommendation-transition-complete'
);

export const SET_RETIRE_RECOMMENDATION_READY_COMPLETE = 'SET_RETIRE_RECOMMENDATION_READY_COMPLETE';
export const setRetireRecommendationReadyComplete = signUpAction(
	SET_RETIRE_RECOMMENDATION_READY_COMPLETE,
	'retire-recommendation-ready-complete'
);

export const SET_RETIRE_IRA_TYPE_SELECTION_COMPLETE = 'SET_RETIRE_IRA_TYPE_SELECTION_COMPLETE';
export const setRetireIraTypeSelectionComplete = signUpAction(
	SET_RETIRE_IRA_TYPE_SELECTION_COMPLETE,
	'retire-ira-type-selection-complete'
);

export const SET_RETIRE_IRA_TYPE_SELECTION_ENTRY_FROM_BYO =
	'SET_RETIRE_IRA_TYPE_SELECTION_ENTRY_FROM_BYO';
export const setRetireIraTypeSelectionEntryFromBYO = signUpAction(
	SET_RETIRE_IRA_TYPE_SELECTION_ENTRY_FROM_BYO,
	'retire-ira-type-selection-entry-from-byo'
);

export const SET_RETIRE_RECOMMENDATION_CONTINUE_COMPLETE =
	'SET_RETIRE_RECOMMENDATION_CONTINUE_COMPLETE';
export const setRetireRecommendationContinueComplete = signUpAction(
	SET_RETIRE_RECOMMENDATION_CONTINUE_COMPLETE,
	'retire-recommendation-continue-complete'
);

export const SET_RETIRE_MANAGED_ACCOUNT_OPEN_TRANSITION_COMPLETE =
	'SET_RETIRE_MANAGED_ACCOUNT_OPEN_TRANSITION_COMPLETE';
export const setRetireManagedAccountOpenTransitionComplete = signUpAction(
	SET_RETIRE_MANAGED_ACCOUNT_OPEN_TRANSITION_COMPLETE,
	'retire-managed-account-open-transition-complete'
);

export const SET_IDV_CHECK_LOADER_COMPLETE = 'SET_IDV_CHECK_LOADER_COMPLETE';
export const setIDVCheckLoaderComplete = signUpAction(
	SET_IDV_CHECK_LOADER_COMPLETE,
	'set-idv-check-loader-complete'
);

export const SET_IDV_SUCCESS_COMPLETE = 'SET_IDV_SUCCESS_COMPLETE';
export const setIDVSuccessComplete = signUpAction(
	SET_IDV_SUCCESS_COMPLETE,
	'set-idv-success-complete'
);

export const SET_PLAN_SELECTION_COMPLETE = 'SET_PLAN_SELECTION_COMPLETE';
export const setPlanSelectionComplete = signUpAction(
	SET_PLAN_SELECTION_COMPLETE,
	'set-plan-selection-complete'
);

export const SET_STOCKPILE_STEP_CONFIRMED = 'SET_STOCKPILE_STEP_CONFIRMED';
export const setStockpileStepConfirmed = (stepName) => ({
	type: SET_STOCKPILE_STEP_CONFIRMED,
	name: `stockpile-${stepName}`,
	value: true,
});

// Multi-year contribution-window exit signal for the Managed Retire funding
// review summary (STASH2026-8587 / STASH2026-8143). Dispatched when the
// destinations API returns more than one eligible contribution year, which
// means we need to defer funding to the post-onboarding SELF_DIRECTED
// multi-year picker. Read by the OnboardingGraph as a transition predicate
// at the `first-deposit-summary` node.
export const SET_ONBOARDING_FUNDING_SKIPPED = 'SET_ONBOARDING_FUNDING_SKIPPED';
export const setOnboardingFundingSkipped = signUpAction(
	SET_ONBOARDING_FUNDING_SKIPPED,
	'onboarding-funding-skipped'
);

export const SET_MANAGED_RETIRE_FUNDING_LINK_BANK = 'SET_MANAGED_RETIRE_FUNDING_LINK_BANK';
export const setManagedRetireFundingLinkBank = signUpAction(
	SET_MANAGED_RETIRE_FUNDING_LINK_BANK,
	'managed-retire-funding-link-bank'
);

// Explicit completion signal for the Managed Retire funding cadence picker
// (STASH2026-8588). Dispatched by the cadence step wrapper when the user picks
// a cadence. The cadence node gates its recurring/one-time exits on this flag
// (NOT on `setSchedule.frequency` alone) because that slot's reducer default is
// a truthy recurring value (`'BI-WEEKLY'`); without an explicit completion gate
// the graph's `getLatestNode` cascade would treat the default as a real choice
// and skip the cadence picker, silently defaulting the user into a recurring
// transfer they never selected.
export const SET_MANAGED_RETIRE_FUNDING_CADENCE_COMPLETE =
	'SET_MANAGED_RETIRE_FUNDING_CADENCE_COMPLETE';
export const setManagedRetireFundingCadenceComplete = signUpAction(
	SET_MANAGED_RETIRE_FUNDING_CADENCE_COMPLETE,
	'managed-retire-funding-cadence-complete'
);
